import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { Card, CardContent } from '@mui/material';

import { PartnershipTierInfo } from './PartnershipTierInfo';

import {
  PARTNERSHIP_TIER_LABELS,
  BRONZE_TIER,
  PARTNERSHIP_TIERS_HEADER,
  STAY_UP_DATE,
} from '../../constants/Pages/PartnerWithUs';

import './PartnerPortal.css';
import './PartnershipTiers.css';

export const PartnershipTiers = () => {
  const [expandedSections, setExpandedSections] = useState(BRONZE_TIER);
  return (
    <div className="partnership-tier-container">
      <div>
        <h2 className="partnership-tier-header">{PARTNERSHIP_TIERS_HEADER}</h2>
        <h5 className="partnership-tier-sub-header">{STAY_UP_DATE}</h5>

        <div className="partnership-tier-body-container">
          <div className="partnership-tier-label-wrapper">
            {PARTNERSHIP_TIER_LABELS.map((overview) => (
              <Card
                key={overview.name}
                sx={{ border: '2px solid black', borderRadius: 3, marginBottom: '10px' }}
                style={
                  overview.name === expandedSections ? { backgroundColor: 'rgb(253, 148, 0)' } : {}
                }
                onClick={() => {
                  setExpandedSections(overview.name);
                  mixpanel.track('Partnership Tier Selection', {
                    partnershipTier: overview.name,
                  });
                }}
              >
                <CardContent
                  className="overview-number"
                  style={{
                    textAlign: 'left',
                    margin: 0,
                    fontSize: '1rem',
                    fontWeight: 500,
                    paddingRight: '1.5rem',
                  }}
                  sx={{
                    '&.MuiCardContent-root:last-child': {
                      paddingBottom: '16px',
                    },
                  }}
                >
                  {overview.title}
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="partnership-tier-info-wrapper">
            <PartnershipTierInfo TierInfo={expandedSections} />
          </div>
        </div>
      </div>
    </div>
  );
};
